export default [
  {
    path: '/invoice/:key?',
    name: 'invoicePage',
    component: () => import(/*webpackChunkName:'invoice'*/ '@/views/invoice/index.vue'),
    meta: {},
  },
];
